export const isProd = () => process.env.NODE_ENV == 'production';

// 线上环境域名是 user.arcsite.com 或者 user.arcsiteapp.com
const ONLINE_HOSTS = ['user.arcsite.com', 'user.arcsiteapp.com'];
export const isOnline = () => {
  const host = window.location.host;
  return ONLINE_HOSTS.includes(host);
};
